define([], function() {
  'use strict';
  return {
    assets: {
      image: '/v1.0/Avatar/{avatar_id}/images/web{resolution}.png'
    }
  };
});
